import "./tablestyle.scss";
import { Grid, GridCellProps, GridColumn as Column, GridSortChangeEvent, GridNoRecords} from "@progress/kendo-react-grid";
import { DropDown } from "./myDropDown";
import { useState } from "react";
import { AllocatedDropdown } from "./allocatedDropdown";
import PopOver from "../popover";
import { DropDownList, DropDownListChangeEvent } from "@progress/kendo-react-dropdowns";
import * as CONSTANTS from '../../utils/CONSTANTS';
import { getMilliSec, getMilliSecUTC } from "../../utils/EllowUtils";
import { useNavigate } from "react-router-dom";
import { updateAvailablity, updateCandidateStatus, deleteDraftFreelancer } from "./services";
import DateEditor from '../../modal/dateEdit'
import WeekEditor from "../../modal/weekEdit"
import TextArea from "../../modal/textArea"
import { orderBy, SortDescriptor } from "@progress/kendo-data-query";
import SelectCertifications from "../../modal/certificationSelect";
import { Icon } from '@iconify/react';
import ConfirmationModal from "../../modal/confirmation/confirmationModal";
import NotificationAlert from "../../components/notification";


const userLoginId = localStorage.getItem('loginId')

const UploadHistoryTable = (props: any) => {

    const [allocatedTo, setAllocatedTo] = useState<any>();
    const [date, setDate] = useState<boolean>(false)
    const [week, setWeek] = useState<boolean>(false)
    const [modal, setModal] = useState<boolean>(false)
    const [loginId, setLoginId] = useState<any>()
    const [candidateStatus, setCandidateStatus] = useState<number>()
    const [showCertification, setShowCertification] = useState<boolean>(false)
    const [certifications, setCertifications] = useState<any>()
    const [confirmation, setConfirmation] = useState<boolean>(false)
    const [notification, setNotification] = useState<boolean>(false)
    const [message, setMessage] = useState<string>('')

    let newDate = new Date()
    const navigate = useNavigate()

    const initialSort: Array<SortDescriptor> = [
        { field: "", dir: "asc" },
    ];

    const [sort, setSort] = useState(initialSort);


    const rowClick = (e: any) => {
        props.rowClick(e)

    }

    const getTableValues = () => {
        props.getResourceTables()

    }

    const dateChange = (data: any) => {
        setLoginId(data.dataItem.loginId)
        setDate(true)
        setWeek(false)
    }

    const weekChange = (data: any) => {
        setLoginId(data.dataItem.loginId)
        setWeek(true)
        setDate(false)
    }

    const rejected = (data: any) => {
        setLoginId(data.dataItem.loginId)
        setCandidateStatus(6)
        setModal(true)

    }

    const blackListed = (data: any) => {
        setLoginId(data.dataItem.loginId)
        setCandidateStatus(7)
        setModal(true)

    }

    const onSubmit = (data: any, type: string) => {
        if (type === 'weeks') {
            let value = {
                "loginId": loginId,
                "availability": {
                    "date": 0,
                    "weeks": data,
                    "availabilityId": 3,
                    "lastUpdateDate": getMilliSecUTC(newDate),

                },
                "userLoginId": userLoginId,
                "submittedBy": 'RECRUITER'
            }
            updateAvailablity(value).then((response: any) => {
                getTableValues()
            })
        }
        if (type === 'date') {
            let value = {
                "loginId": loginId,
                "availability": {
                    "date": data,
                    "weeks": 0,
                    "availabilityId": 2,
                    "lastUpdateDate": getMilliSecUTC(newDate),
                },
                "userLoginId": userLoginId,
                "submittedBy": 'RECRUITER'
            }
            updateAvailablity(value).then((response: any) => {
                getTableValues()
            })
        }
    }

    const submitRemarks = (data: any) => {

        let value = {
            "loginId": loginId,
            "userLoginId": userLoginId,
            "candidateStatus": candidateStatus,
            "rejectComment": data
        }
        updateCandidateStatus(value).then((response: any) => {
            if (response && response.status === 1) {
                getTableValues()
            }
        })
    }
    //vishnu
    const openInNewTab = (url: any) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };
    const redirection = (candidateLoginId: string) => {
        // localStorage.setItem('candidateLoginId', candidateLoginId);
        localStorage.setItem('ResourcesCandidateLoginId', candidateLoginId);
        localStorage.setItem('ResourcesTab', '6');
        openInNewTab(`${window.location.origin}/createResources`)
        //navigate('../createResources', { state: { candidateLoginId: candidateLoginId, tab: 4 } })
    }

    function ShowCertificationPopup(data: any) {
        setLoginId(data.dataItem.loginId);
        setShowCertification((prev) => !prev)
        setCertifications(data.dataItem.ellowScreeningCertifications);
    }

    const deleteMyDraft = (data: any) => {
        setLoginId(data.dataItem.loginId)
        setConfirmation(true)
    }

    const deleteMyDraftFreelancer = () => {
        deleteDraftFreelancer(loginId).then((response: any) => {
            if (response.statusCode === 200) {
                props.getResourceTables()
                setMessage('Details deleted successfully')
                displayNotification()
            }
        })
    }

    const certificationCell = (props: GridCellProps) => {
        let ellowScreeningCertifications = props.dataItem.ellowScreeningCertifications;
        let length = ellowScreeningCertifications && ellowScreeningCertifications.length;
        let skillcombine = ellowScreeningCertifications && ellowScreeningCertifications.map((dataskill: any) => {
            return dataskill.skills && dataskill.skills.name;
        }
        ).join(",");
        return (
            <td onClick={() => ShowCertificationPopup(props)}>
                <div className="positionStstus no-wrap">
                    <PopOver title={skillcombine}
                        position="Bottom">
                        {ellowScreeningCertifications && ellowScreeningCertifications.map((skillData: any, key: any) => {
                            return (<div key={key} className="positionList">   <span className="status warning" /><strong>{skillData.skills && skillData.skills.name} - {skillData.certificationType} </strong> </div>);
                        })}
                    </PopOver>
                </div>
            </td>
        )
    }

    const displayNotification = () => {
        setNotification(true)
        setTimeout(() => {
            setNotification(false)
        }, 3000)
    }

    const onClose = () => {
        setNotification(false)
    }

    return (
        <>
            <Grid
                data={props.state.items}
                onPageChange={props.pageChange}
                total={props.state.total}
                skip={props.state.skip}
                pageable={props.state.pageable}
                pageSize={props.state.pageSize}
                onItemChange={props.itemChange}
                onRowClick={(e) => rowClick(e)}
                // data={props.state.items && orderBy(props.state.items, sort)}
                // onSortChange={(e: GridSortChangeEvent) => {
                //   setSort(e.sort); props.getTableValues()
                // }}
                sortable={true}
                sort={sort}
                onSortChange={(e) => {
                    setSort(e.sort);
                    props.setSort(e.sort);
                    props.applySort(e.sort);

                }}
            >
                <GridNoRecords>
                    <div className="noData">
                        <Icon icon="mdi:smiley-neutral-outline" />
                        No data to display
                    </div>
                </GridNoRecords>
                <Column field="created_time" title="Uploaded on" width="180" cell={dateCell} />
                <Column field="file_name" title="filename" />
                <Column field="total_rows" title="total number of rows" />
                <Column field="total_successful_uploaded" title="rows uploaded successfully" />
                <Column field="total_duplicate_rows" title="duplicate rows" />
                <Column field="duplicate_entries" title="duplicate data" cell={duplicate_entriesCell} />
                <Column field="added_by_user_name" title="uploaded by" />



            </Grid>


        </>
    )
}

export default UploadHistoryTable;



const dateCell = (props: GridCellProps) => {
    let dateNumber = parseInt(props.dataItem.created_time);
    let date = new Date(dateNumber).toDateString();

    return <td><div className="dateWrap">{date}</div></td>;
};



const duplicate_entriesCell = (props: GridCellProps) => {

    let length = props.dataItem.duplicate_entries && props.dataItem.duplicate_entries.length;

    return (
        <td >
            <div className="skillsWrap">
                {props.dataItem.duplicate_entries && props.dataItem.duplicate_entries.map((item: string, key: number) => {
                    return ((item) + (key < length - 1 ? ' , ' : ''))
                })}
            </div>
        </td>
    );
};











